// import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";
// import { FormProvider, useForm } from "react-hook-form";
// import { toast } from "sonner";

// import { Button } from "@/components/ui/button";
// import { Card, CardContent } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
// import {
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "@/components/ui/form";
// import { Input } from "@/components/ui/input";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
// import { Textarea } from "@/components/ui/textarea";
import { useSession } from "@/lib/auth/client";
// import { sendContactEmail } from "@/lib/email/email-service";
// import { ContactFormSchema } from "@/lib/validation/contact-form";
// import type { ContactFormData } from "@/lib/validation/contact-form";

const ContactUs: React.FC<{
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}> = ({ open, onOpenChange }) => {
  const { data: session } = useSession();
  const user = session?.user;
  const router = useRouter();

  // const form = useForm<ContactFormData>({
  //   resolver: zodResolver(ContactFormSchema),
  //   // defaultValues: {
  //   //   subject: "",
  //   //   category: "General Inquiry",
  //   //   message: "",
  //   // },
  //   values: {
  //     subject: "",
  //     category: "General Inquiry",
  //     message: "",
  //   },
  // });

  useEffect(() => {
    if (open && !user) {
      onOpenChange?.(false);
      router.push("/signin");
    }
  }, [open, user, router, onOpenChange]);

  // const onSubmit = async (data: ContactFormData) => {
  //   if (!user?.email) return;

  //   try {
  //     await sendContactEmail(data);

  //     toast("Thank you for your submission", {
  //       description: "We'll get back to you as soon as possible.",
  //     });

  //     // Reset form fields on successful submission
  //     form.reset({
  //       subject: "",
  //       category: "General Inquiry",
  //       message: "",
  //     });

  //     // Close modal and notify parent for any follow-up actions
  //     onOpenChange?.(false);
  //     onSubmitted?.();
  //   } catch (error: unknown) {
  //     // Handle validation errors from backend
  //     if (
  //       error &&
  //       typeof error === "object" &&
  //       "type" in error &&
  //       error.type === "validation" &&
  //       "details" in error &&
  //       Array.isArray(error.details)
  //     ) {
  //       error.details.forEach((detail: { path: string[]; message: string }) => {
  //         form.setError(detail.path[0] as keyof ContactFormData, {
  //           type: "server",
  //           message: detail.message,
  //         });
  //       });
  //       toast("Please fix the validation errors", {
  //         description: "Check the form fields for details.",
  //       });
  //     } else {
  //       toast("Error sending message", {
  //         description: "Please try again later.",
  //       });
  //     }
  //   }
  // };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Contact us</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Our support team is here to help with any questions or account issues.
          Email us at{" "}
          <a
            href="mailto:support@apartmentdibs.com"
            className="font-geist text-primary underline hover:no-underline"
          >
            support@apartmentdibs.com
          </a>{" "}
        </p>
        {/* <FormProvider {...form}>
              <form
                onSubmit={form.handleSubmit(onSubmit)}
                className="space-y-4"
              >
                <div className="grid grid-cols-2 gap-4 md:grid-cols-2">
                  <FormField
                    control={form.control}
                    name="subject"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel htmlFor="subject">Subject</FormLabel>
                        <FormControl>
                          <Input
                            id="subject"
                            placeholder="Enter subject"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="category"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel htmlFor="category">Category</FormLabel>
                        <FormControl>
                          <Select
                            onValueChange={field.onChange}
                            defaultValue={field.value}
                          >
                            <SelectTrigger className="w-full">
                              <SelectValue placeholder="Select a category" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="General Inquiry">
                                General inquiry
                              </SelectItem>
                              <SelectItem value="Technical Issue">
                                Technical issue
                              </SelectItem>
                              <SelectItem value="Billing Question">
                                Billing question
                              </SelectItem>
                              <SelectItem value="Feature Request">
                                Feature request
                              </SelectItem>
                              <SelectItem value="Other">Other</SelectItem>
                            </SelectContent>
                          </Select>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="space-y-2">
                  <FormField
                    control={form.control}
                    name="message"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel htmlFor="message">Message</FormLabel>
                        <FormControl>
                          <Textarea
                            id="message"
                            placeholder="Please describe your issue or question in detail..."
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex justify-end">
                  <Button
                    type="submit"
                    variant="default"
                    className="cursor-pointer"
                    disabled={
                      form.formState.isSubmitting || !form.formState.isDirty
                    }
                  >
                    {form.formState.isSubmitting
                      ? "Sending..."
                      : "Send message"}
                  </Button>
                </div>
              </form>
            </FormProvider> */}
      </DialogContent>
    </Dialog>
  );
};

export default ContactUs;
